module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-4.b904b9bc.svg";